const e = () => typeof navigator < "u" ? /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) : !0;
export {
  e as isMobileDevice
};
